



















import Base from './Base.vue';
import { RozsahDate } from '../constants';

export default Base.extend({
	name: 'OdpisPP',
	components: {
		BaseFilterSestav: Base,
	},
	created() {
		this.RozsahDate = RozsahDate.casMinulyMesic;
	},
});
